import { CallCoverageSummary } from "./CallCoverageSummary";

export const CallCoverageReport = {
  "sections": [
    CallCoverageSummary
  ]
}